import { Component, OnInit, ViewEncapsulation, HostListener, Inject } from '@angular/core';
import { HomeService } from './home.service';
import { NotificationService } from '../shared/services/notification.service';
import { Router } from '@angular/router';
import { Constants } from '../shared/constants';
import { TitleMetadataService } from '../shared/services/title-metadata.service';
import { WINDOW } from '../shared/services/general-operations.service';
import { SearchSpringScriptsService } from '../shared/services/search-spring-scripts.service';
import { environment } from './../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HomePageComponent {
  loaded = false;
  homeHeroResponse: any;
  subtotal = 0;
  breadcrumbs: any[];
  cartEmptyMessage = false;
  frequentlyPurchasedSlideConfig: any;

  slidesToShow: number = 5;
  slidesToScroll: number = this.slidesToShow;

  slidesToShowGuides: number = 1;
  slidesToScrollGuides: number = this.slidesToShowGuides;
  featuredCategories: any;
  active = true;
  frequentlyProjectGuides: {
    slidesToShow: number;
    slidesToScroll: number;
    dots: boolean;
    infinite: boolean;

  };
  categoryString: string = '';
  pageString: string = '';
  filterString: string = '';
  sortString: string = '';
  shoppingCartByIdData: any = {};
  showImageDots: boolean = false;
  constructor(
    @Inject(WINDOW) private window: Window,
    private homeService: HomeService,
    private router: Router,
    private notificationService: NotificationService,
    private titleService: TitleMetadataService,
    private searchSpringScriptsService: SearchSpringScriptsService,
    private sanitizer: DomSanitizer
  ) {
    this.titleService.createCanonicalURL(this.router.url);
    this.getFeaturedCategories();
    this.getHomeHeroResponse();
    this.adjustCarouselItems(this.window);
    this.setSliderConfigurations();
  }

  ngOnInit() {
    this.titleService.updateTitle(Constants.homePageTitle);
    this.titleService.updateDescription(Constants.homePageDescription);
  }

  // Apply and remove Category
  categorizeBy(subFilter: any, filterBy: string): void {
    this.pageString = '';
    if (this.categoryString.indexOf('q=') > 0) {
      this.categoryString += `&filter.${filterBy}=${subFilter.value}&category=true`;
    } else {
      this.categoryString = `&filter.${filterBy}=${subFilter.value}&category=true`;
    }
    this.navigateWithFilters();
  }

  // Trigger Search Spring API with filters
  navigateWithFilters() {
    this.router.navigate(['/product'],
      {
        queryParams: { filterBy: this.categoryString + this.filterString + this.sortString + this.pageString },
        queryParamsHandling: 'merge'
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.adjustCarouselItems(event.target);
    this.setSliderConfigurations();
  }

  async deferLoad() {
    const carouselButtons: any = document.querySelectorAll('.slick-arrow');
    if (carouselButtons.length) {
      carouselButtons.forEach((element: any) => {
        element.addEventListener("click", () => {
          setTimeout(() => {
            const carouselItem: any = document.querySelector('.slick-current')
            if (carouselItem && carouselItem.tagName == 'A') {
              carouselItem.focus();
            } else {
              const carouselItem2: any = document.querySelector('.slick-current .product-list__item');
              if (carouselItem2 && carouselItem2.tagName == 'A') {
                carouselItem2.focus();
              }
            }
          }, 100)
        });
      });
    }
  }

  async adjustCarouselItems(windows): Promise<void> {
    this.showImageDots = false;
    if (windows.innerWidth <= 420) {
      this.slidesToScroll = 1;
      this.slidesToShow = 1;
    } else if (windows.innerWidth <= 1025) {
      this.slidesToScroll = 3;
      this.slidesToShow = 3;
    } else {
      this.slidesToScroll = 5;
      this.slidesToShow = 5;
    }
  }

  async setSliderConfigurations(): Promise<void> {
    this.frequentlyPurchasedSlideConfig = {
      slidesToShow: this.slidesToShow,
      slidesToScroll: this.slidesToScroll,
      dots: this.showImageDots,
      infinite: false
    };
    this.frequentlyProjectGuides = {
      slidesToShow: this.slidesToShowGuides,
      slidesToScroll: this.slidesToScrollGuides,
      dots: true,
      infinite: false
    };
  }

  // learn more guide
  learnMoreGuide(guideUrl) {
    this.window.open(Constants.productSupportURL, 'blank');


  }

  // View All Guides
  viewAllGuides() {
    this.window.open(Constants.viewAllGuides, 'blank');
  }  // Dynamic Breadcrumb

  transform(value: string) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  // Get home hero response from post operation
  async getHomeHeroResponse(): Promise<void> {
    this.homeService.getHomeHeroResponse()
      .subscribe(res => {
        res.merchandising.content.header[0] = res.merchandising.content.header[0].replaceAll('<div','<div defer fetchpriority="high" loading="eager" ');
        res.merchandising.content.banner[0] = res.merchandising.content.banner[0].replaceAll('<img','<img defer fetchpriority="high" loading="eager" ');
        this.homeHeroResponse = res;
        if(this.homeHeroResponse.merchandising && this.homeHeroResponse.merchandising.content && this.homeHeroResponse.merchandising.content.header) {
          this.homeHeroResponse.merchandising.content.header = this.homeHeroResponse.merchandising.content.header.map((el:any) =>  {
            return this.transform(el)
          })
        }
        if(this.homeHeroResponse.merchandising && this.homeHeroResponse.merchandising.content && this.homeHeroResponse.merchandising.content.banner) {
          this.homeHeroResponse.merchandising.content.banner = this.homeHeroResponse.merchandising.content.banner.map((el:any) => {
            return this.transform(el)
          })
        }
        this.loaded = true;
        this.deferLoad();

        if (environment.domainURL === 'https://www.jdprodwebapp.com') {
          this.titleService.addMetaTags('robots', 'noindex');
        }
      }, err => {
        this.notificationService.showError(err);
      });
  }

  // navigate to about us page
  navigateToAboutUs() {
    this.router.navigate(['/organization/about-us']);
  }

  toggleModal(): void {
    this.active = !this.active;
  }

  // Get -  Feauterd Categories response from post operation
  async getFeaturedCategories() {
    this.homeService.getFeaturedCategories()
      .subscribe(res => {
        this.featuredCategories = res;

      }, err => {
        this.notificationService.showError(err);
      });
  }

  getUrl(categoryFilter): any {
    return categoryFilter.replace(/ /g, '-');
  }

  intellisuggestProductTrackClick(element: any, data: any, signature: any) {
    this.searchSpringScriptsService.addIntellisuggestProductTrackClick(element, data, signature);

    return true;
  }
}
